import angular from 'angular';

// TODO: PK remove this module once we can confirm that we can still build
export default angular
  .module('csm.util.Flash', [])
  .factory('Flash', flashFactory)
  .name;

flashFactory.$inject = [];
    
/*****************************************************************************
 * Flash */
/**
 * Flash player utilities.
 *****************************************************************************/
/* @ngInject */
function flashFactory() {
  var service = {};

  /***************************************************************************
   * isEnabled */
  /**
   * Returns true if flash is installed and enabled.
   ***************************************************************************/
  service.isEnabled = function () {
    try {
      return new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
    } catch (e) {
      if (navigator.mimeTypes)
        if (navigator.mimeTypes['application/x-shockwave-flash'])
          if (
            navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin
          )
            return true;
    }
    return false;
  };

  return service;
}
